export default __webpack_public_path__ + "static/media/cloudy.4e0858f0.svg";